import React from 'react';
import { useTheme } from '@/context/ThemeContext';
import { motion } from 'framer-motion';
import { SUCCESS_METRICS, TESTIMONIALS, TYPEFORM_URL } from '@/data/mock';
import { SectionHeading, StatCard, CTAButton } from '@/components/shared/SharedComponents';
import { Quote } from 'lucide-react';

export default function CasosDeExitoPage() {
  const { currentTheme: t, theme } = useTheme();

  return (
    <div style={{ fontFamily: 'Inter, sans-serif' }}>
      {/* Hero */}
      <section className="pt-28 lg:pt-36 pb-16 lg:pb-24" style={{ background: t.heroBg }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.h1 initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="text-4xl lg:text-5xl font-bold mb-4" style={{ color: t.text, fontFamily: 'Manrope, sans-serif' }}>
            Casos de Éxito
          </motion.h1>
          <motion.p initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 }} className="text-lg max-w-2xl mx-auto" style={{ color: t.textSecondary }}>
            Empresas que confían en Motivy para transformar su cultura organizacional.
          </motion.p>
        </div>
      </section>

      {/* Stats */}
      <section className="py-16" style={{ background: t.bg }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 lg:gap-6">
            {SUCCESS_METRICS.map((m, i) => <StatCard key={i} {...m} index={i} />)}
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-16 lg:py-24" style={{ background: t.sectionAltBg }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <SectionHeading heading="Testimonios de nuestros clientes" />
          <div className="grid md:grid-cols-3 gap-8">
            {TESTIMONIALS.map((test, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.15 }}
                className="p-8 rounded-xl border"
                style={{ background: t.cardBg, borderColor: t.cardBorder }}
              >
                <Quote size={24} className="mb-4" style={{ color: t.accent, opacity: 0.5 }} />
                <p className="text-sm leading-relaxed mb-6 italic" style={{ color: t.textSecondary }}>
                  «{test.quote}»
                </p>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full flex items-center justify-center text-sm font-bold" style={{ background: t.featureIconBg, color: t.featureIconColor }}>
                    {test.initials}
                  </div>
                  <div>
                    <p className="text-sm font-semibold" style={{ color: t.text }}>{test.name}</p>
                    <p className="text-xs" style={{ color: t.textMuted }}>{test.role}</p>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16" style={{ background: t.bg }}>
        <div className="max-w-3xl mx-auto text-center px-4">
          <h2 className="text-3xl font-bold mb-6" style={{ color: t.text, fontFamily: 'Manrope, sans-serif' }}>¿Quieres ser el próximo caso de éxito?</h2>
          <CTAButton href={TYPEFORM_URL} />
        </div>
      </section>
    </div>
  );
}
